import { 
    Box,
    Grid,
    GridItem,
    Hide,
    Flex,
    Button,
    Text,
    Popover,
    PopoverTrigger,
    PopoverContent,
    PopoverBody,
    useMediaQuery 
} from '@chakra-ui/react'
import { QuestionOutlineIcon } from '@chakra-ui/icons';
import { HomeProps, Profile } from '../../types';
import TableItem from './TableItem';
import MobileTableItem from './MobileTableItem';

const Table: React.FC<HomeProps> = ({ olympInfo }) => {
    const [isSmallScreen] = useMediaQuery('(max-width: 1199px)');
  
    return(
        <Flex 
            gap={{ 
              base: '20px',
              xl: 0 
            }}
            mt='20px'
            mb='30px'
            mx={{
                base: '24px', 
                xl: '100px'
            }}
            flexDirection='column'
            fontSize='16px'
            lineHeight='20px'
            >
            <Hide below='xl'>
              <Grid 
                pt='30px'
                fontSize='14px'
                lineHeight='19px'
                color='#1D438A'
                templateColumns='16% 33% 10% 18% 23%'
              >
                  <GridItem pr='20px'>
                      <Box as='b' mr='5px'>
                          Профиль олимпиады и год
                      </Box>
                      <Popover trigger="hover">
                          <PopoverTrigger>
                            <QuestionOutlineIcon boxSize='15px'/>
                          </PopoverTrigger>
                          <PopoverContent>
                            <PopoverBody color='#151515'>
                              Обратите внимание, профиль олимпиады может называться как угодно, но 100 баллов 
                              или БВИ будет даваться <Box as='span' color='#f9b233'>согласно условиям получения</Box>
                            </PopoverBody>
                          </PopoverContent>
                      </Popover>
                  </GridItem>
                  <GridItem px='20px' as='b'>
                      Условия получения ИД или ВИ
                  </GridItem>
                  <GridItem px='10px'>
                      <Box as='b' mr='5px'>
                        ИД
                      </Box>
                      <Popover trigger="hover">
                          <PopoverTrigger>
                            <QuestionOutlineIcon boxSize='15px'/>
                          </PopoverTrigger>
                          <PopoverContent>
                            <PopoverBody color='#151515'>
                              Обратитесь к организаторам олимпиады после проведения (желательно сразу!), 
                              чтобы <Box as='span' color='#f9b233'>получить документальное подтверждение своего статуса</Box>
                            </PopoverBody>
                          </PopoverContent>
                      </Popover>
                  </GridItem>
                  <GridItem px='20px'>
                      <Box as='b' mr='5px'>
                          ВИ, по которым предоставляется право на 100 баллов (только по результатам за 9-11 классы)
                      </Box>
                      <Popover trigger="hover">
                          <PopoverTrigger>
                            <QuestionOutlineIcon boxSize='15px'/>
                          </PopoverTrigger>
                          <PopoverContent>
                            <PopoverBody color='#151515'>
                              <Box as='span' color='#f9b233'>Лайфхак:</Box> иногда имеет смысл отказаться от права получить 100 баллов и получить 
                              10 баллов в виде индивидуальных достижений (например, если у Вас {'>'}91 балла по предмету и нет других индивидуальных достижений)
                            </PopoverBody>
                          </PopoverContent>
                      </Popover>
                  </GridItem>
                  <GridItem px='20px'>
                      <Box as='b' mr='5px'>
                          НП/С, по которым установлено право на приём БВИ (только по результатам за 9-11 классы)
                      </Box>
                      <Popover trigger="hover">
                          <PopoverTrigger>
                            <QuestionOutlineIcon boxSize='15px'/>
                          </PopoverTrigger>
                          <PopoverContent>
                            <PopoverBody color='#151515'>
                              Если Вы не хотите поступать по данным образовательным программам, Вы <Box as='span' color='#f9b233'>можете отказаться</Box> от
                              этого права <Box as='span' color='#f9b233'>и получить 10 баллов</Box> в виде индивидуальных достижений
                            </PopoverBody>
                          </PopoverContent>
                      </Popover>
                  </GridItem>
              </Grid>
            </Hide>
            {olympInfo.profiles.map((profile: Profile, i: number) => (
                isSmallScreen ?
                <MobileTableItem 
                  key={i}
                  profile={profile}
                  isLast={false}
                /> :
                <TableItem 
                  key={i}
                  profile={profile}
                  isLast={i === olympInfo.profiles.length - 1}
                />
                
            ))}
        </Flex>
    )
}

export default Table;